import React from 'react'
import PropTypes from 'prop-types'
import PartnerTable from './partner-table'
import PartnerTableLinkCell from './partner-table-link-cell'
import * as Types from 'types'

const propTypes = {
  nameField: PropTypes.string,
  partners: PropTypes.arrayOf(Types.partnership).isRequired,
  type: Types.searchResultType.isRequired,
  schoolYearId: PropTypes.number,
  programNames: PropTypes.arrayOf(PropTypes.string).isRequired,
}

const defaultProps = {
  nameField: 'name',
}

const getPartnershipDisplayName = (partner, type) => {
  if (type === Types.ARTIST_TYPE) {
    return partner.artistName
  } else if (type === Types.PARTNER_TYPE) {
    return partner.organizationName
  } else if (type === Types.SCHOOL_TYPE) {
    return partner.schoolName
  }
}

function getPartnerDetailState(partner, type) {
  if (type === Types.ARTIST_TYPE) {
    return partner.artistState
  } else if (type === Types.PARTNER_TYPE) {
    return partner.organizationState
  } else if (type === Types.SCHOOL_TYPE) {
    return partner.schoolState
  }
}

function MapPartnerTable({
  partners,
  nameField,
  type,
  schoolYearId,
  programNames,
}) {
  return (
    <PartnerTable
      rows={partners.map((p) => ({
        ...p,
        type,
        [nameField]: getPartnershipDisplayName(p, type),
        partnerState: getPartnerDetailState(p, type),
        schoolYearId: schoolYearId,
      }))}
      nameColumn={{ name: nameField, component: PartnerTableLinkCell }}
      programNames={programNames}
    />
  )
}

MapPartnerTable.propTypes = propTypes
MapPartnerTable.defaultProps = defaultProps

export default MapPartnerTable
